/* Lichcards lc-fx — speelse micro-interacties (27-09-2026). Stijl en uitleg: assets/lc-fx.css.
   Alleen visueel: dit script verandert niets aan winkelwagen, verlanglijst of zoeken; het kijkt
   alleen mee en zet tijdelijke klassen. Niets bij prefers-reduced-motion. */
(function () {
  'use strict';
  if (!window.matchMedia || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var COLORS = ['#1693c1', '#fece7b', '#e72630', '#43b254', '#83509a']; // de vijf figuurtjes uit het logo

  /* Klasse opnieuw laten afspelen en na afloop weer weghalen */
  function replay(el, cls, ms) {
    if (!el) return;
    var restarting = el.classList.contains(cls);
    el.classList.remove(cls);
    // Only flush layout when an active effect needs to start again.
    if (restarting) void el.offsetWidth;
    el.classList.add(cls);
    clearTimeout(el['_lcFx' + cls]);
    el['_lcFx' + cls] = setTimeout(function () { el.classList.remove(cls); }, ms || 800);
  }

  /* Blaadjes-burst vanuit het midden van een element (of vanaf een punt) */
  function burst(el, big) {
    if (!el || !el.getBoundingClientRect) return;
    var r = el.getBoundingClientRect();
    if (!r.width && !r.height) return;
    burstAt(r.left + r.width / 2, r.top + r.height / 2, big, Math.max(r.width, r.height));
  }
  function burstAt(x, y, big, size) {
    var n = big ? 10 : 5;
    var box = document.createElement('span');
    box.className = 'lc-fx-burst' + (big ? ' lc-fx-burst--big' : '');
    box.setAttribute('aria-hidden', 'true');
    box.style.left = x.toFixed(1) + 'px';
    box.style.top = y.toFixed(1) + 'px';
    var start = Math.random() * 72;
    for (var i = 0; i < n; i++) {
      var p = document.createElement('i');
      var angle = start + i * (360 / n) + (Math.random() * 16 - 8);
      var dist = (big ? 30 : 20) + Math.random() * (big ? 16 : 8) + Math.min(size || 0, 80) * 0.25;
      var rad = angle * Math.PI / 180;
      p.style.setProperty('--c', COLORS[i % COLORS.length]);
      p.style.setProperty('--r', angle.toFixed(0) + 'deg');
      p.style.setProperty('--dx', (Math.sin(rad) * dist).toFixed(1) + 'px');
      p.style.setProperty('--dy', (-Math.cos(rad) * dist).toFixed(1) + 'px');
      p.style.setProperty('--k', String(i % 5));
      box.appendChild(p);
    }
    document.body.appendChild(box);
    setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 1100);
  }

  function visible(el) {
    return !!el && el.classList.contains('active');
  }

  /* ---------- Indrukken: knoppen, spellen, onderbalk, spaarpunten ---------- */
  var PRESS = [
    '.product-form__submit', 'sticky-atc button[type="submit"]', '.lc-index-card__add', '.quick-add__submit',
    '.rd-btn', '.cart__checkout-button', '#CartDrawer-Checkout', '.lc-so-jump', '.rd-chip',
    '.lc-restock__form button', '.lc-sh__shuffle', '.rd-game', '.rd-sheet__game',
    '#lc-singles .lc-index__games button', '.rd-bnav__item', '.lc-kb__points'
  ].join(',');
  document.addEventListener('pointerdown', function (event) {
    var el = event.target && event.target.closest ? event.target.closest(PRESS) : null;
    if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true') return;
    replay(el, 'lc-fx-press', 950);
  }, { passive: true });

  /* ---------- Verlanglijst: hartje popt bij toevoegen ---------- */
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('.wishlist-button') : null;
    if (!btn) return;
    var was = btn.getAttribute('aria-pressed') === 'true' || btn.classList.contains('wishlist-added');
    var done = false;
    [80, 300, 800].forEach(function (ms) {
      setTimeout(function () {
        if (done) return;
        var now = btn.getAttribute('aria-pressed') === 'true' || btn.classList.contains('wishlist-added');
        if (!was && now) {
          done = true;
          replay(btn, 'lc-fx-heart', 750);
          burst(btn.querySelector('svg') || btn);
          Array.prototype.forEach.call(document.querySelectorAll('.wishlist-count-bubble'), function (b) { replay(b, 'lc-fx-bump', 700); });
        }
      }, ms);
    });
  }, true);

  /* ---------- Zoekloep wiebelt bij focus ---------- */
  var SEARCH_WRAP = '.lc-sh__search, .rd-hero__search, .lc-index__search, .search-modal, .search-drawer, form[action*="/search"], label';
  var SEARCH_ICON = '.lc-sh__search-icon, .rd-hero__search-icon, .lc-index__search > span:not([class*="visually-hidden"]), svg.icon-search, .icon-search, .search__button svg, button[type="submit"] svg';
  document.addEventListener('focusin', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('input[type="search"], input[name="q"]')) return;
    var wrap = input.closest(SEARCH_WRAP);
    var icon = wrap ? wrap.querySelector(SEARCH_ICON) : null;
    if (icon && !icon.closest('.loading__spinner')) replay(icon, 'lc-fx-wiggle', 700);
  });

  /* ---------- Winkelwagenlade: nieuw product landt, gratis verzending gehaald, tasje hupt ---------- */
  /* Alleen na een echte toevoeg-actie van de bezoeker (knop of formulier), zodat het openen van de
     lade of het herladen van de inhoud nooit een effect geeft. */
  var armedAt = 0;
  var ADD = '.product-form__submit, sticky-atc button[type="submit"], .quick-add__submit, .add-to-cart-button, .lc-index-card__add, cart-drawer button[name="plus"], button[name="add"]';
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest && event.target.closest(ADD)) armedAt = Date.now();
  }, true);
  document.addEventListener('submit', function (event) {
    var f = event.target;
    if (f && f.getAttribute && /\/cart\/add/.test(f.getAttribute('action') || '')) armedAt = Date.now();
  }, true);
  var armed = function () { return Date.now() - armedAt < 8000; };

  var drawer = document.querySelector('cart-drawer');
  if (drawer && window.MutationObserver) {
    var snapshot = function () {
      var map = {};
      Array.prototype.forEach.call(drawer.querySelectorAll('.cart-item'), function (row) {
        var link = row.querySelector('a[href*="variant="]');
        var m = link ? /variant=(\d+)/.exec(link.getAttribute('href')) : null;
        var key = m ? m[1] : row.getAttribute('data-line') || row.id;
        var input = row.querySelector('input[name="updates[]"], .quantity__input');
        /* Het value-attribuut komt van de server (bevestigd aantal). De value-eigenschap loopt al
           vooruit zodra je op + tikt, ook als de winkel daarna "slechts 1 op voorraad" meldt. */
        var raw = input ? (input.getAttribute('value') || input.value) : '1';
        var qty = parseInt(raw, 10) || 1;
        map[key] = (map[key] || 0) + qty;
      });
      return map;
    };
    var freeShipComplete = function () {
      var el = drawer.querySelector('lc-free-shipping');
      return el ? el.classList.contains('is-complete') : false;
    };
    var last = snapshot();
    var lastFree = freeShipComplete();
    var pendingHop = false;
    var wasOpen = visible(drawer);
    var timer = 0;

    var hopBag = function () {
      pendingHop = false;
      var targets = Array.prototype.slice.call(document.querySelectorAll('.header__icon--cart'));
      Array.prototype.forEach.call(document.querySelectorAll('.rd-bnav__item'), function (item) {
        if (item.querySelector('.rd-bnav__count')) targets.push(item);
      });
      targets.forEach(function (t) {
        var r = t.getBoundingClientRect();
        if (!r.width) return;
        replay(t, 'lc-fx-hop', 900);
        burst(t.querySelector('.cart-count-bubble, .rd-bnav__count') || t);
      });
    };

    var whenOpen = function (fn) {
      var tries = 0;
      var tick = function () {
        if (visible(drawer) || tries > 8) { setTimeout(fn, 320); return; }
        tries += 1;
        setTimeout(tick, 100);
      };
      tick();
    };

    var check = function () {
      timer = 0;
      var now = snapshot();
      if (!Object.keys(now).length) { lastFree = false; return; } /* lege (tussen)stand: vorige stand bewaren */
      var landed = [];
      Object.keys(now).forEach(function (key) {
        if (!(key in last) || now[key] > last[key]) landed.push(key);
      });
      last = now;

      var free = freeShipComplete();
      var reachedFree = free && !lastFree;
      lastFree = free;
      if (!armed()) return;

      if (landed.length) {
        pendingHop = true;
        whenOpen(function () {
          if (!visible(drawer)) { hopBag(); return; }
          landed.forEach(function (key) {
            var link = drawer.querySelector('.cart-item a[href*="variant=' + key + '"]');
            var row = link ? link.closest('.cart-item') : null;
            if (!row) return;
            replay(row, 'lc-fx-landed', 900);
            /* Blaadjes alleen als de foto echt in beeld is (niet weggescrold in de lade) */
            var img = row.querySelector('.cart-item__image-container') || row;
            var ir = img.getBoundingClientRect();
            var box = row.closest('.cart-drawer__form') || drawer;
            var br = box.getBoundingClientRect();
            var cy = ir.top + ir.height / 2;
            if (ir.width && cy > br.top && cy < br.bottom && cy > 0 && cy < window.innerHeight) burst(img);
          });
        });
      }
      if (reachedFree) {
        whenOpen(function () {
          if (!visible(drawer)) return;
          var fs = drawer.querySelector('lc-free-shipping.is-complete');
          if (!fs) return;
          var badge = fs.querySelector('.lc-fs__badge');
          var br = badge ? badge.getBoundingClientRect() : null;
          if (br && br.width) { burst(badge, true); return; }
          /* In de lade is alleen de regel zichtbaar: blaadjes vanaf het begin van de regel */
          var line = fs.querySelector('.lc-fs__foot') || fs;
          var lr = line.getBoundingClientRect();
          if (lr.width) burstAt(lr.left + 14, lr.top + lr.height / 2, true, 28);
        });
      }
    };

    var snapshotNode = '.cart-item, lc-free-shipping';
    var affectsSnapshot = function (record) {
      if (record.type === 'attributes') {
        if (record.attributeName === 'value') {
          return record.target.matches('input[name="updates[]"], .quantity__input') &&
            !!record.target.closest('.cart-item');
        }
        if (record.attributeName === 'class' && record.target.matches('lc-free-shipping')) {
          return /(?:^|\s)is-complete(?:\s|$)/.test(record.oldValue || '') !==
            record.target.classList.contains('is-complete');
        }
        return false;
      }
      if (record.type !== 'childList') return false;
      if (record.target.closest?.('.cart-item')) return true;
      return Array.prototype.some.call(record.addedNodes, snapshotChanged) ||
        Array.prototype.some.call(record.removedNodes, snapshotChanged);
    };
    var snapshotChanged = function (node) {
      if (!(node instanceof Element)) return false;
      return node.matches(snapshotNode) ||
        (!!node.firstElementChild && !!node.querySelector(snapshotNode));
    };
    new MutationObserver(function (records) {
      if (!records.some(affectsSnapshot)) return;
      if (!timer) timer = setTimeout(check, 60);
    }).observe(drawer, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['class', 'value'], attributeOldValue: true
    });

    var visibilityTimer = 0;
    new MutationObserver(function (records) {
      if (!records.some(function (record) {
        return /(?:^|\s)active(?:\s|$)/.test(record.oldValue || '') !== visible(drawer);
      })) return;
      clearTimeout(visibilityTimer);
      visibilityTimer = setTimeout(function () {
        visibilityTimer = 0;
        var open = visible(drawer);
        if (wasOpen && !open && pendingHop) hopBag();
        wasOpen = open;
      }, 380);
    }).observe(drawer, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
  }

  /* ---------- Voorraadmelding opgeslagen: blaadjes ---------- */
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('.lc-restock__form')) return;
    var host = form.closest('lichcards-restock-alert');
    var status = host ? host.querySelector('[data-restock-status]') : null;
    var ok = host ? host.getAttribute('data-success-label') : '';
    if (!status || !ok || !window.MutationObserver) return;
    var obs = new MutationObserver(function () {
      if ((status.textContent || '').trim() === ok.trim()) {
        obs.disconnect();
        burst(status, true);
      }
    });
    obs.observe(status, { childList: true, characterData: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }, true);
})();
